import React, { createContext, useContext, useEffect, useState } from "react";
import { api, getStoredUser, setAuth, clearAuth } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cpl_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("cpl_user", JSON.stringify(r.data));
      })
      .catch(() => clearAuth())
      .finally(() => setLoading(false));
  }, []);

  const login = (token, user) => {
    setAuth(token, user);
    setUser(user);
  };
  const logout = () => {
    clearAuth();
    setUser(null);
  };
  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
